import { useEffect, useState } from "react";

const TypeWriter = ({ text, id, delay = 1000, speed = 20 }: { text: string; id?: string; delay?: number, speed?: number }) => {
  const [displayText, setDisplayText] = useState(() => {
    const storedText = localStorage.getItem(`typedText-${id}`);
    return storedText || '';
  });
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    // Reset displayText if text changes
    const storedText = localStorage.getItem(`typedText-${id}`);
    if (storedText && storedText.length === text.length) {
      setDisplayText(storedText);
      setIsTyping(false);
    } else {
      setDisplayText('');
      setIsTyping(false);
    }
  }, [text, id]);

  useEffect(() => {
    if (displayText.length < text.length) {
      // Start typing after the delay
      const startTimer = setTimeout(() => {
        setIsTyping(true);
      }, delay);

      return () => clearTimeout(startTimer);
    }
  }, [text, delay, displayText]);

  useEffect(() => {
    if (!isTyping) return;

    let currentIndex = displayText.length;

    const typingInterval = setInterval(() => {
      if (currentIndex < text.length) {
        const newText = text.substring(0, currentIndex + 1);
        setDisplayText(newText);
        localStorage.setItem(`typedText-${id}`, newText); // Store in localStorage
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTyping(false); // Stop typing once complete
      }
    }, speed);

    return () => clearInterval(typingInterval);
  }, [isTyping, text]);

  return <span>{displayText.includes('\n') ? displayText.split('\n').map((line, index) => <div key={index}>{line}</div>) : displayText}</span>;
};

export default TypeWriter;
